export class ForeignHealthEndDateStudent {
  time: string
  min: string
  max: string
  constructor(data: any = {}) {
    this.time = data.time || 'month'
    this.min = data.min || '2'
    this.max = data.max || '12'
  }
}
